<div class="direct-booking-container" data-test="direct-booking-modal">
  <div class="header-container">
    <div 
      class="header" 
      data-test="direct-booking-header" 
      [class.completing-account]="bookingState() === bookingStates.COMPLETING_ACCOUNT || bookingState() === bookingStates.ADDING_EBCG_PAYMENT || bookingState() === bookingStates.ADDING_PAYMENT_METHOD"
    >
      @if (isLoadingInitialData()) {
        <span class="skeleton-loader header-skeleton"></span>
      } @else if (forceAccountCompletion() && (bookingState() === bookingStates.INITIAL || bookingState() === bookingStates.INITIAL_WITHOUT_TIMESLOTS || bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS)) {
        <span>Next step</span>
      } @else if ([bookingStates.INITIAL, bookingStates.INITIAL_WITHOUT_TIMESLOTS, bookingStates.NEW_CLIENT_NO_TIMESLOTS, bookingStates.EXISTING_CLIENT_NO_TIMESLOTS, bookingStates.ALREADY_PROPOSED_TIME].includes(bookingState())) {
        @if (providerProfile?.hasDirectScheduling) {
          <span>Schedule your session</span>
        } @else {
          <span>Confirm your session request</span>
        }
      } @else if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
        <span>Add this provider to your matched providers</span>
      } @else if(bookingState() === bookingStates.CONFIRMED) {
        <span>
          <iris-icon
            class="icon"
            [size]="irisIconSizes.LG"
            name="check"
            colorToken="$color-brand-1-base"
          ></iris-icon>
            <span>Your session is confirmed</span>
        </span>
      } @else if(bookingState() === bookingStates.REQUESTED) {
        <span>
          <iris-icon
            class="icon"
            [size]="irisIconSizes.LG"
            name="check"
            colorToken="$color-brand-1-base"
          ></iris-icon>
            <span>Session requested</span>
        </span>
      } @else if(bookingState() === bookingStates.ERROR) {
        <span class="error-message">
          <iris-icon
            [size]="irisIconSizes.SM"
            name="error"
            [color]="iconColors.DANGER"
          ></iris-icon>
          {{ errorMessage }}
        </span>
      } @else if (bookingState() === bookingStates.RESCHEDULE) {
        @if(providerProfile?.hasDirectScheduling) {
          <span>Reschedule your session</span>
        } @else {
          <span>Request to reschedule</span>
        }
      } @else if (bookingState() === bookingStates.CANCELLING) {
        <span>Cancel your session</span>
      } @else if (bookingState() === bookingStates.COMPLETING_ACCOUNT) {
        <iris-progress-bar
          [percentComplete]="acProgressBarValue()"
          class="account-completion-progress"
        ></iris-progress-bar>
      } @else if (bookingState() === bookingStates.ADDING_EBCG_PAYMENT || bookingState() === bookingStates.ADDING_PAYMENT_METHOD) {
        <span class="empty-header"></span>
      } @else if (bookingState() === bookingStates.CONFIRM_DISCARD_BOOKING) {
        <span>Are you sure you want to exit?</span>
      }

      @if (!isInNativeApp && !(bookingState() === bookingStates.CONFIRM_DISCARD_BOOKING)) {
        <iris-icon-button
          icon="close"
          ariaLabel="Close"
          [type]="irisIconButtonTypes.TERTIARY"
          class="close-add-edit-button"
          (click)="(forceAccountCompletion() || bookingState() === bookingStates.ADDING_EBCG_PAYMENT || bookingState() === bookingStates.ADDING_PAYMENT_METHOD) ? showConfirmDiscardBooking() : dismissModal()"
          data-test="direct-booking-close-button"
          [type]="irisIconButtonTypes.TERTIARY"
        >
        </iris-icon-button>
      }
    </div>

    <div class="subheader" data-test="direct-booking-subheader">
      @if (isLoadingInitialData()) {
        <span class="skeleton-loader subheader-skeleton"></span>
      } @else if (forceAccountCompletion() && (bookingState() === bookingStates.INITIAL || bookingState() === bookingStates.INITIAL_WITHOUT_TIMESLOTS || bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS)) {
        Complete your account to finish booking your session
      } @else if (bookingState() === bookingStates.INITIAL || bookingState() === bookingStates.RESCHEDULE || bookingState() === bookingStates.INITIAL_WITHOUT_TIMESLOTS) {
        @if (providerProfile?.hasDirectScheduling) {
          Confirm your session details below
        } @else {
          Review the details below and confirm your session request
        }
      } @else if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
        You'll be able to send {{provider.displayName}} a message after you add them to your matched providers.
      } @else if (bookingState() === bookingStates.ERROR) {
        Please choose another time.
      } @else if (bookingState() === bookingStates.CANCELLING) {
        Confirm below
      } @else if (bookingState() === bookingStates.REQUESTED) {
        We'll notify you when your session is approved.
      } @else if (bookingState() === bookingStates.CONFIRM_DISCARD_BOOKING) {
        <span>By exiting, you will lose this session time and have to start over.</span>
      }
    </div>
  </div>

  @if (bookingState() === bookingStates.CONFIRM_DISCARD_BOOKING) {
  <div class="action-buttons">
    <button
      class="cancel-button iris-button iris-button--secondary"
      data-test="direct-booking-nevermind-button"
      (click)="bookingState.set(previousBookingState() ?? bookingStates.INITIAL)"
    >
      Nevermind
    </button>
    <button
      class="confirm-button iris-button iris-button--danger"
      data-test="direct-booking-yes-exit-button"
      (click)="dismissModal()"
    >
      Yes, Exit
    </button>
    </div>
  } @else {
    <div class="content-container">
      @if (bookingState() !== bookingStates.COMPLETING_ACCOUNT && 
           bookingState() !== bookingStates.ADDING_EBCG_PAYMENT &&
           bookingState() !== bookingStates.ADDING_PAYMENT_METHOD) {
        <div
          class="card"
          data-test="direct-booking-provider-card"
          *ngIf="provider"
        >
          <div class="photo-container">
            <provider-photo
              class="provider-photo"
              [initials]="provider.displayName | initials"
              [photoUrl]="provider.profilePhotoUrl"
              [providerName]="provider.displayName"
            >
            </provider-photo>
          </div>
  
          <div class="timeslot">
            @if(timeslot) {
              <span class="slot">
                {{ timeslot.startTime | localizedDate:{ weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' } }} -
                {{ timeslot.endTime | localizedDate:{ hour: 'numeric', minute: '2-digit' } }}
                ({{ timezone }})
              </span>
            }
            @if(canChangeTime()) {
              <button
                class="change-time"
                data-test="direct-booking-change-time-button"
                (click)="changeTime(!changingTime())">
                Change
              </button>
            }
      
          </div>
          <div class="info">
            @if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
              <div class="therapy-with">{{provider.displayName}}{{certifications?.length ? ', ' + certifications.join(',') : ''}}</div>
              <div>Therapy</div>
            } @else {
              <div class="therapy-with">Therapy with {{provider.displayName}}{{certifications?.length ? ', ' + certifications.join(',') : ''}}</div>
              <div class="section session-type">
                <div class="icon-container">
                  <iris-icon
                    class="icon"
                    [size]="irisIconSizes.SM"
                    name="videocam_outline"
                    colorToken="$color-brand-1-base"
                  ></iris-icon>
                </div>
                <span class="session">{{ sessionType }}
                  @if (isInPersonSession()
                  && inPersonSessionLocation().length > 0
                  && (bookingState() === bookingStates.CONFIRMED || bookingState() === bookingStates.INITIAL_WITHOUT_TIMESLOTS)) {
                    {{ ` at ${inPersonSessionLocation()}` }}
                  }
                </span> 
              </div>
              <div class="section">
                <div class="icon-container">
                  @if (showCostEstimate()) {
                    <iris-icon
                      class="icon"
                      [size]="irisIconSizes.SM"
                      name="dollar"
                      colorToken="$color-brand-1-base"
                    ></iris-icon>
                  } @else {
                    <iris-icon
                      class="icon"
                      [size]="irisIconSizes.SM"
                      name="shield_health"
                      colorToken="$color-brand-1-base"
                    ></iris-icon>
                  }
                </div>
  
                <coverage-badge
                  [providerId]="provider.providerId"
                ></coverage-badge>
                @if (showCostEstimate()) {
                  <span class="cost-estimate">
                    {{verifiedInsuranceAmount | currency}}/est cost with {{verifiedInsuranceNames()}}
                  </span>
                }
                <sonder-tooltip [desktopTooltipText]="tooltipText()">
                  <iris-icon
                    *ngIf="tooltipText()"
                    displayText
                    class="info-icon no-underline"
                    [size]="irisIconSizes.MD"
                    name="info"
                    colorToken="$color-action-base"
                  ></iris-icon>
  
                  <ng-container mobileBody>
                    <p class="iris-legal-responsive">
                      {{tooltipText()}}
                    </p>
                  </ng-container>
                </sonder-tooltip>
              </div>
            }
          </div>
  
          @if (changingTime()) {
            <div class="change-time-container">
              @if (isLoadingLocations()) {
                <!-- Use one loader overall -->
                <mat-spinner diameter="50" class="change-time-loader"></mat-spinner>
              } @else {
                <appointment-session-type-select
                  [locations]="providerLocations()"
                  [sessionTypesOffered]="provider?.sessionTypesOffered"
                  [currentSelection]="selectedLocation()"
                  (sessionTypeChange)="handleAppointmentSessionTypeSelected($event)"
                >
                </appointment-session-type-select>
                @if (!loadingTimeslots() && 
                  (bookingState() !== bookingStates.EXISTING_CLIENT_NO_TIMESLOTS
                  || bookingState() !== bookingStates.NEW_CLIENT_NO_TIMESLOTS)
                ) {
                  <div class="change-time-header">
                    Choose a session time
                  </div> 
                }

                @if (loadingTimeslots()) {
                  <!-- Use a secondary loader if the locations are loaded but still waiting on slots -->
                  <mat-spinner diameter="50" class="change-time-loader"></mat-spinner>
                } @else if (appointmentSlots().length > 0) {
                  <appointment-carousel
                    [appointmentSlots]="appointmentSlots()"
                    [useBrowserTimezone]="true"
                    (appointmentSlotSelectionChanged)="handleAppointmentSlotSelectionChanged($event)"
                  >
                  </appointment-carousel>
                }
              }
            </div>
          }
        </div>
      }

      @if (bookingState() === bookingStates.ADDING_PAYMENT_METHOD) {
        <client-setup-payment-info
          #paymentInfoComponent
          [fromDirectBooking]="true"
          (paymentInfoSubmitted)="handlePaymentMethodAdded()"
        ></client-setup-payment-info>
      }

      @if (showPaymentExplanationBlock()) {
        <div class="payment-explanation-container">
          <div class="payment-explanation-card">
            <div class="payment-explanation-icon">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="credit_card"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>

            <div>
              <p class="payment-explanation-text">
                Please add an updated payment method to finish booking.
              </p>

              <sonder-tooltip [desktopTooltipText]="paymentExplanationTooltipText()">
                <p displayText class="payment-explanation-tooltip-text">
                  Why do I need to add a payment method?
                </p>

                <ng-container mobileBody>
                  <p class="iris-body-responsive">
                    {{ paymentExplanationTooltipText() }}
                  </p>
                </ng-container>
              </sonder-tooltip>
            </div>
          </div>
        </div>
      }
    
      @if (bookingState() === bookingStates.EXISTING_CLIENT_NO_TIMESLOTS) {
        <div class="no-availability-container">
          <div class="no-availability-content">
            <span>
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="calendar_month"
                colorToken="$color-neutral-default"
              ></iris-icon>
            </span>
            <span class="no-availability-text">
              {{provider.displayName}} is currently fully booked
            </span>
          </div>
          <button class="iris-button iris-button--tertiary" data-test="direct-booking-message-provider-button" (click)="messageProvider()">
            Message provider
          </button>
        </div>
      } @else if (bookingState() === bookingStates.ALREADY_PROPOSED_TIME) {
        <div class="no-availability-container">
          <span>
            <iris-icon
            class="icon"
            [size]="irisIconSizes.LG"
            name="access_time"
            colorToken="$color-neutral-default"
          ></iris-icon>
          </span>
          <span class="no-availability-text">
            You already have a session request waiting for {{provider.displayName}}'s approval
          </span>
        </div>
      }
  
      @if (bookingState() === bookingStates.CONFIRMED || bookingState() === bookingStates.REQUESTED) {
        @if (userNeedsSetup()) {
          <div class="update-card-container">
            <div class="update-card-header">
              <span class="call-out-text">Important:</span>
              Complete your account 24 hours before your session
            </div>
            <div class="needs-setup">
              <session-task [taskType]="sessionTaskType.ACCOUNT_INFO"></session-task>
            </div>
          </div>
        } @else {
          @if (hasMultipleIssues()) {
            <div class="update-card-container">
              <div class="update-card-header">
                Update your insurance before your session
              </div>
              <div class="update-card-subheader">
                The following information must be updated more than 24 hours ahead of your session to avoid the risk of cancellation. 
              </div>
            </div>
          }
          @if (canAddInsurance()) {
            <div class="update-card-container">
              <div class="update-card-header">
                Add your benefits before your session
              </div>
              <div class="update-card">
                <div class="update-icon">
                  <iris-icon
                    class="icon"
                    [size]="irisIconSizes.MD"
                    name="shield_health"
                    colorToken="$color-brand-1-base"
                  ></iris-icon>
                </div>
                <div class="update-content">
                  <div>
                    Most insurance plans cover mental health services, which can reduce your costs to as little as $20-$40.
                  </div>
                  <div class="update-content-text">
                    We'll check your benefits and give an estimated cost based on your plan details.
                  </div>
                </div>
              </div>
            </div>
          }
          @if (hasUnverifiedInsurance()) {
            <div class="update-card-container">
              <div class="update-card-header" *ngIf="!hasMultipleIssues()">
                Update your insurance before your session
              </div>
              <div class="update-card">
                <div class="update-icon">
                  <iris-icon
                    class="icon"
                    [size]="irisIconSizes.MD"
                    name="shield_health"
                    colorToken="$color-brand-1-base"
                  ></iris-icon>
                </div>
                <div class="update-content">
                  <div class="update-card-header">
                    Insurance
                  </div>
                  <div class="update-card-body" *ngIf="!hasMultipleIssues()">
                    Must be updated more than <b>24 hours before your session</b> to avoid session cancellation. 
                  </div>
                  <div class="update-card-info">
                    <b>{{ unverifiedInsuranceNames() }}</b>
                    <span class="update-card-info-expired">Unverified</span>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (hasExpiredInsurance()) {
            <div class="update-card-container">
              <div class="update-card-header" *ngIf="!hasMultipleIssues()">
                Update your insurance before your session
              </div>
              <div class="update-card">
                <div class="update-icon">
                  <iris-icon
                    class="icon"
                    [size]="irisIconSizes.MD"
                    name="shield_health"
                    colorToken="$color-brand-1-base"
                  ></iris-icon>
                </div>
                <div class="update-content">
                  <div class="update-card-header">
                    Insurance
                  </div>
                  <div class="update-card-body" *ngIf="!hasMultipleIssues()">
                    Must be updated more than <b>24 hours before your session</b> to avoid session cancellation. 
                  </div>
                  <div class="update-card-info">
                    <b>{{ expiredInsuranceNames() }}</b>
                    <span class="update-card-info-expired">No longer valid</span>
                  </div>
                </div>
              </div>
            </div>
          }
          
          @if (expiredCreditCard()) {
            <div class="update-card-container">
              <div class="update-card-header" *ngIf="!hasMultipleIssues()">
                Update your payment method before your session
              </div>
          
              <div class="update-card">
                <div class="update-icon">
                  <iris-icon
                    class="icon"
                    [size]="irisIconSizes.MD"
                    name="credit_card"
                    colorToken="$color-brand-1-base"
                  ></iris-icon>
                </div>
                <div class="update-content">
                  <div class="update-card-header">
                    Payment
                  </div>
                  <div class="update-card-body" *ngIf="!hasMultipleIssues()">
                    must be updated more than <b>24 hours before your session</b>
                    to avoid session cancellation.
                  </div>
                  <div class="update-card-info">
                    <img src="assets/card-logos/{{expiredCreditCard()?.brand}}.svg" alt="visa" class="update-card-info-brand">
                      •••• •••• •••• {{expiredCreditCard()?.last4}}
                    <span class="update-card-info-expired">Expired</span>
                  </div>
                </div>
                
              </div>
            </div>
          }
        } 
      }
  
      @if (bookingState() === bookingStates.COMPLETING_ACCOUNT) {
        <client-account-setup
          #accountSetupComponent
          [user]="currentUser.user$ | async"
          [processing]="setupProcessing()"
          [isInsuranceEmpty]="isInsuranceEmpty()"
          [hasSelfPayInsuranceRecord]="hasSelfPayInsuranceRecord()"
          [costEstimateContext]="costEstimateContext()"
          [fromDirectBooking]="true"
          [ebcgEmbraceProviderFromDirectBooking]="providerProfile?.ebcgEmbraceProvider ?? false"
          [providerNameFromDirectBooking]="providerProfile?.displayName ?? ''"
          [providerPersonaProviderId]="provider?.providerId"
          [providerIsPsychiatrist]="providerProfile?.isPsychiatrist ?? false"
          [isTelehealthAppointment]="timeslot?.sessionType !== sessionPreference.IN_PERSON"
          (setupDataSubmit)="reloadUser()"
          (setupConfirmed)="confirmSession()"
          (setupExited)="exitSetupAndNavigate()"
          (progressBarValueUpdate)="updateProgressBar($event)"
        ></client-account-setup>
      }


      @if (bookingState() === bookingStates.ADDING_EBCG_PAYMENT) {
        <client-setup-ebcg-payment-info
          #ebcgPaymentComponent
          [fromDirectBooking]="true"
          [providerName]="providerProfile?.displayName ?? provider.displayName"
          [userProfile]="currentUser.user?.profile"
          (paymentInfoSubmitted)="handleEbcgPaymentSubmitted()"
          (exitSetup)="exitSetupAndNavigate()"
        ></client-setup-ebcg-payment-info>
      }
    </div>
  
    <div class="action-buttons" data-test="direct-booking-action-buttons">
      @if ([bookingStates.INITIAL, bookingStates.INITIAL_WITHOUT_TIMESLOTS, bookingStates.NEW_CLIENT_NO_TIMESLOTS, bookingStates.ERROR].includes(bookingState())) {
        @if(!forceAccountCompletion()) {
          <button
            class="cancel-button iris-button iris-button--secondary"
            data-test="direct-booking-cancel-button"
            (click)="closeModal(false)"
          >
            Cancel
          </button>
        }
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-confirm-button"
          (click)="confirmSession()"
          [disabled]="submittingSession() || isLoadingInitialData()"
        >
          @if(forceAccountCompletion()) {
            Complete my account
          } @else if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
            Add to matches
          } @else if (isLoadingInitialData()) {
            Loading...
          } @else if ((needsEbcgPayment() || needsCreditCardForBooking()) && bookingFlow === bookingFlows.EXISTING_CLIENT && !currentUser.user?.needsSetup) {
            Next
          } @else {
            Confirm request
          }
          <mat-spinner 
            diameter="20" 
            class="confirm-button-spinner" 
            *ngIf="submittingSession() || isLoadingInitialData()"
          ></mat-spinner>
        </button>
      }
      @else if (bookingState() === bookingStates.RESCHEDULE) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          data-test="direct-booking-reschedule-cancel-button"
          (click)="closeModal(false)"
        >
          Cancel
        </button>
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-reschedule-confirm-button"
          (click)="rescheduleSession()"
          [disabled]="submittingSession()"
        >
          Confirm session
          <mat-spinner 
            diameter="20" 
            class="confirm-button-spinner" 
            *ngIf="submittingSession()"
          ></mat-spinner>
        </button>
      }
      @else if (bookingState() === bookingStates.CANCELLING) {
        @if (canRescheduleInCancelState()) {
          <button
            class="cancel-button iris-button iris-button--secondary"
            data-test="direct-booking-reschedule-session-button"
            (click)="rescheduleCanceledSession()"
          >
            Reschedule session
          </button>
        }
  
        <button
          class="cancel-session-button iris-button iris-button--danger"
          data-test="direct-booking-cancel-session-button"
          (click)="cancelSession()"
          [disabled]="submittingSession()"
        >
          Cancel session
          <mat-spinner 
            diameter="20" 
            class="cancelled-button-spinner" 
            *ngIf="submittingSession()"
          ></mat-spinner>
        </button>
      }
      @else if(bookingState() === bookingStates.EXISTING_CLIENT_NO_TIMESLOTS || bookingState() === bookingStates.ALREADY_PROPOSED_TIME) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          data-test="direct-booking-close-button-no-timeslots"
          (click)="closeModal(false)"
        >
          Close
        </button>
      }
      @else if (bookingState() === bookingStates.ADDING_EBCG_PAYMENT) {
        <!-- Render the action button from the EBCG payment component -->
        <ng-container *ngTemplateOutlet="ebcgPaymentComponent()?.actionButtonTemplate()"></ng-container>
      }
      @else if (bookingState() === bookingStates.ADDING_PAYMENT_METHOD) {
        <ng-container *ngTemplateOutlet="paymentInfoComponent()?.actionButtonTemplate()"></ng-container>
      }
      @else if (userNeedsSetup()) {
        @if (forceAccountCompletion()) {
          <!-- Render the action button from the current account setup step -->
          <ng-container *ngTemplateOutlet="accountSetupComponent()?.accountSetupActionButton()"></ng-container>
        } @else if (!forceAccountCompletion()) {
          <button
            class="confirm-button iris-button iris-button--primary"
            data-test="direct-booking-complete-account-button"
            (click)="navigateToAccountSetup()"
          >
            Complete my account
          </button>
        }
      }
      @else if (expiredCreditCard()) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          data-test="direct-booking-dismiss-expired-card-button"
          (click)="dismissModal()"
        >
          I'll do this before my session
        </button>
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-update-credit-card-button"
          (click)="updateCreditCard()"
        >
          Update details now
        </button>
      }
      @else if ((coverageNotificationService?.hasUnverifiedInsurance$ | async) 
                || (coverageNotificationService?.hasExpiredInsurance$ | async)) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          data-test="direct-booking-dismiss-insurance-button"
          (click)="dismissModal()"
        >
          I'll do this before my session
        </button>
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-update-insurance-button"
          (click)="updateInsurance()"
        >
          Update details now
        </button>
      }
      @else if (canAddInsurance()) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          data-test="direct-booking-continue-cash-pay-button"
          (click)="dismissModal()"
        >
          Continue with cash pay
        </button>
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-add-insurance-button"
          (click)="updateInsurance()"
        >
          Add insurance
        </button>
      }
      @else {
        <button
          class="confirm-button iris-button iris-button--primary"
          data-test="direct-booking-done-button"
          (click)="dismissModal()"
        >
          Done
        </button>
      }
    </div>

    @if (showConnectWithoutScheduling() && !timeslot?.startTime && provider) {
      <div class="connect-without-scheduling" data-test="direct-booking-connect-without-scheduling">
        <span class="connect-text">Not ready to schedule just yet?</span>
        <span class="connect-link-text">
          <a
            class="connect-link"
            data-test="direct-booking-connect-link"
            (click)="addProviderToMatchesViaLink()"
          >Click here</a> to connect with {{ provider.displayName }} now and decide on a time together later.
        </span>
      </div>
    }
  }
</div>
